export default "__VITE_ASSET__819f009f__"